import { useMutation, useQueryClient } from '@tanstack/react-query';
import { messagesApi } from '../lib/api';

// Invalida tutte le query che mostrano tag di un messaggio, così la UI si aggiorna
// dopo add/remove: dettaglio messaggio, feed AI e liste messaggi. Invalida anche
// l'elenco tag (può essere stato creato un tag nuovo) e i KPI.
function invalidateTagRelated(qc: ReturnType<typeof useQueryClient>) {
  qc.invalidateQueries({ queryKey: ['message'] });
  qc.invalidateQueries({ queryKey: ['feed'] });
  qc.invalidateQueries({ queryKey: ['messages'] });
  qc.invalidateQueries({ queryKey: ['tags'] });
  qc.invalidateQueries({ queryKey: ['tag-kpi'] });
}

// Aggiunge un tag al messaggio: tag esistente ({tagId}) o nuovo ({name}).
export function useAddMessageTag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      messageId,
      tag,
    }: {
      messageId: string;
      tag: { name: string } | { tagId: string };
    }) => messagesApi.addTag(messageId, tag),
    onSuccess: () => invalidateTagRelated(qc),
  });
}

// Rimuove il collegamento tra un tag e il messaggio.
export function useRemoveMessageTag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ messageId, tagId }: { messageId: string; tagId: string }) =>
      messagesApi.removeTag(messageId, tagId),
    onSuccess: () => invalidateTagRelated(qc),
  });
}
